module.exports = __webpack_public_path__ + "img/pauli-y-root-dagger-0.f3a09835.svg";